import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
    '577d66e7ca3f5cbbc946be3505773b09T1JERVI6MzY1OTUsRVhQSVJZPTE2NzQ3Mjg4MzgwMDAsS0VZVkVSU0lPTj0x',
  );